import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { PruebaAlergiaNuevo } from './PruebaAlergiaNuevo';
import { PruebaAlergiaPrevia } from './PruebaAlergiaPrevia';
import { PruebaAlergiaEditar } from './PruebaAlergiaEditar';
import { Forbidden } from '../../../components';

import styles from '../PacienteConsulta.module.css';

export const PruebaAlergia = () => {

    let { id } = useParams();

    const { permisos } = useSelector(state => state.auth);

    let defaultTab = 4;

    if(permisos.pruebaAlergiaCreate){
        defaultTab = 1;
    }else if(permisos.pruebaAlergiaRead){
        defaultTab = 2;
    }

    const [tab, setTab] = useState(defaultTab);

    const [pruebaActual, setPruebaActual] = useState({});

    return (
        <>
            <div className="row">
                <div className="col">
                    <div className={styles.tabsSubHeader}>Pruebas de alergia</div>
                    <div  className={styles.tabsContainerInner + " mt-3"}>
                        <div className={"row"}>
                            {(permisos.pruebaAlergiaCreate) &&
                            <div className="col p-0 text-center">
                                <div className={ (tab === 1) ? styles.tabActiveInner : styles.tabInner } onClick={() => setTab(1)}>Nueva</div>
                            </div>
                            }
                            {(permisos.pruebaAlergiaRead && (!permisos.pruebaAlergiaUpdate || tab !== 3)) &&
                            <div className="col p-0 text-center">
                                <div className={ (tab === 2) ? styles.tabActiveInner : styles.tabInner } onClick={() => setTab(2)}>Previas</div>
                            </div>
                            }
                            {(permisos.pruebaAlergiaUpdate && tab === 3) &&
                            <div className="col p-0 text-center">
                                <div className={ styles.tabActiveInner }>Editar</div>
                            </div>
                            }
                        </div>
                    </div>
                    <div className={styles.tabsContentContainerInner}>
                        { (permisos.pruebaAlergiaCreate && tab === 1) && <PruebaAlergiaNuevo id={id} /> }
                        { (permisos.pruebaAlergiaRead && tab === 2) && <PruebaAlergiaPrevia id={id} editar={() => setTab(3)} setPruebaActual={setPruebaActual} /> }
                        { (permisos.pruebaAlergiaUpdate && tab === 3) && <PruebaAlergiaEditar id={id} pruebaData={pruebaActual} cancelar={() => setTab(2)} /> }
                        { (tab === 4) && <Forbidden /> }
                    </div>
                </div>
            </div>
        </>
    )
}
